<template>
  <div class="doctor">
    <div class="top">
      <p class="unlimited" @click="more">不限</p>
      <p class="btn" @click="toOrder">确定</p>
    </div>
    <div class="doctorList">
      <ul>
        <li class="item" v-for="(item, index) in doctorlist" :key="index" @click="toSelect(index)">
          <img class="avatar" :src="item.imgUuid" alt="" @click.prevent="handleClick(item.id)">
          <div class="info">
            <p class="name" @click.prevent="handleClick(item.id)">{{item.name}}</p>
            <p class="rank">{{item.level}}</p>
            <p class="num">接诊量：{{item.orderCount}}</p>
            <p class="good">擅长：{{item.baseInfo}}</p>
          </div>
          <img class="select" src="../../../../assets/images/courier/selected.png" alt="" v-if="i.includes(index)">
          <img class="select" src="../../../../assets/images/courier/no_select.png" alt="" v-else>
        </li>
      </ul>
<!--      <div class="pagin">-->
<!--        <pagination :pageCount="pageCount" @pageSize="pageSize" />-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import Pagination from '../../../../components/Pagination'
import {reqAllDoctor, reqDoctor, reqHospitalInfo} from '../../../../api'
export default {
  data () {
    return {
      i: [] ,
      doctorlist: [], // 医生列表
      // pageCount:0,
      data: {}
    }
  },
  created() {
    const {hospitalId, departmentIdA, departmentIdB, nameLike, departmentIdAName,departmentIdBName} = this.$route.query
    this.data = {
      departmentIdA,
      departmentIdB,
      hospitalId,
      nameLike,
      departmentIdAName,
      departmentIdBName
      // pageIndex:1
    }
    this._reqDoctor()
  },
  methods: {
    // 获取医生列表
    _reqDoctor() {
      reqAllDoctor(this.data).then(res => {
        if(res.code === 200){
          this.doctorlist = res.data.bussData
        }
      })
    },
    // 选择医生
    toSelect (i) {
      // this.i = [];
      if(this.i.includes(i)) {
        this.i = this.i.filter((item) => {
          return item != i
        })
      } else {
        this.i.push(i)
      }
    },
    // 去详情页面
    handleClick (id) {
      this.$router.push({name: 'DoctorDetail', query: {id}})
    },
    // 点击确定
    toOrder () {
      if(this.i.length) {
        const doctors = []
        this.i.forEach((item) => {
          this.doctorlist.forEach((item1, index1) => {
            if(item == index1) {
              doctors.push(item1)
            }
          })
        })
      var departmentIdA = this.data.departmentIdA
      var departmentIdB = this.data.departmentIdB
      var departmentIdAName = this.data.departmentIdAName
      var departmentIdBName = this.data.departmentIdBName
        reqHospitalInfo(doctors[0].hospitalId).then(res => {
          if(res.code === 200){
            this.$store.dispatch('getHospitalInfo', res.data.bussData)
            this.$store.dispatch('getDoctorInfo', doctors).then(() => {
              this.$router.push({name: 'HospitalOrder', query: {departmentIdA,departmentIdB,departmentIdAName,departmentIdBName}})
            })
          }
        })

      } else {
        this.$message({
          message: '请选择一个医生',
          type: 'error'
        })
      }

    },
    // 点击不限
    more() {
      Object.assign(this.data, {pageSize: 1000})
      var departmentIdA = this.data.departmentIdA
      var departmentIdB = this.data.departmentIdB
      var departmentIdAName = this.data.departmentIdAName
      var departmentIdBName = this.data.departmentIdBName
      reqDoctor(this.data).then(res => {
        console.log(res)
        if(res.code === 200){
          this.doctorlist = res.data.bussData
          // this.pageCount = res.data.pageCount
          this.$store.dispatch('getDoctorInfo', this.doctorlist).then(() => {
            this.$router.push({name: 'HospitalOrder', query: {departmentIdA,departmentIdB,departmentIdAName,departmentIdBName}})
          })
        }
      })

    },
    // 分页
    pageSize(num) {
      this.data.pageIndex = num
      this._reqDoctor()
    }
  },
  watch: {
    $route() {
      const {hospitalId, departmentIdA, departmentIdB} = this.$route.query
      const body = {
        departmentIdA,
        departmentIdB,
        hospitalId,
        // pageIndex:1
      }
      this._reqDoctor(body)
    }
  },
  components: {
    Pagination
  }
}
</script>

<style scoped lang="less" type="text/less">
  .doctor{
    float: left;
    width: 1020px;
    margin-bottom: 46px;
    .top{
      display: flex;
      justify-content: flex-end;
      overflow: hidden;
      margin-bottom: 20px;
      p{
        width: 80px;
        height: 39px;
        text-align: center;
        line-height: 39px;
        border-radius: 20px;
        box-sizing: border-box;
        cursor: pointer;
        &.unlimited{
          margin-right: 15px;
          border:1px solid #e1e1e1;
        }
        &.btn{
          background: #2FA1DE;
          color:#fff;
        }
      }

    }
    .doctorList{
      ul{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .item{
          display: flex;
          position: relative;
          width: 480px;
          height: 220px;
          margin-bottom: 20px;
          padding:20px;
          box-sizing: border-box;
          box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
          cursor: pointer;
          .avatar{
            display: block;
            width: 180px;
            height: 180px;
            margin-right: 20px;
            background: #ccc;
          }
          .info{
            width: 240px;
            .name{
              margin-bottom: 12px;
              font-size: 18px;
              font-weight: bold;
              font-family:PingFang-SC-Bold;
            }
            .rank{
              margin-bottom: 17px;
              color:#61aee6;
            }
            .num{
              margin-bottom: 15px;
            }
            .good{
              height: 84px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 6;
              line-height: 20px;
              overflow: hidden;
            }
          }
          .select{
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
    }
    .pagin{
      margin-top:40px;
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Courier/Children/Hospital/Doctor.vue